import { PayloadAction, createSlice } from '@reduxjs/toolkit';

export interface InterviewQuestion {
  id: number;
  question: string;
  sort: number;
}

export interface InterviewQuestionResponse {
  author: number;
  created_at: string;
  id: number;
  question: string;
  order: number;
  report: string;
  updated_at: string;
}

type InterviewPlannerState = {
  interviewQuestions: InterviewQuestion[];
};

const initialState: InterviewPlannerState = {
  interviewQuestions: [],
};

export const interviewPlannerSlice = createSlice({
  name: 'interviewPlanner',
  initialState,
  reducers: {
    // saves to redux store and updates the API
    setInterviewQuestions: (
      state,
      action: PayloadAction<InterviewQuestion[]>,
    ) => {
      state.interviewQuestions = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setInterviewQuestions } = interviewPlannerSlice.actions;

export default interviewPlannerSlice.reducer;
